import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { formattedError } from 'src/app/_helper/functions';

export interface AlertError {
  alert_class: 'alert-danger' | 'alert-warning';
  text: string;
}

@Component({
  selector: 'app-form-alert',
  templateUrl: './form-alert.component.html',
})
export class FormAlertComponent implements OnInit, OnChanges {
  @Input() err_msg: AlertError;
  text_msg;

  ngOnInit() {
    this.parseMessage();
  }

  ngOnChanges() {
    this.parseMessage();
  }

  parseMessage() {
    if (!this.err_msg?.text)
      this.text_msg = 'Parse message error \n' + JSON.stringify(this.err_msg);
    else {
      this.text_msg = formattedError(this.err_msg.text);
    }
  }
}
